import {
    GET_ALL_EQUIPMENTS,
    CURRENT_PAGE, PRELOADER
} from './constants';

const initialState = {
    equipments: [],
    pages: null,
    currentPage: 0,
    preloader: true
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_EQUIPMENTS: {
            return {
                ...state,
                equipments: action.payload.items,
                pages: action.payload.pages,
                preloader: false
            };
        }
        case PRELOADER: {
            return {
                ...state,
                preloader: action.payload,
            };
        }
        case CURRENT_PAGE: {
            return {
                ...state,
                currentPage: action.payload
            };
        }
        default:
            return state;
    }
};

